// react
import styled from 'styled-components';

type DividerColor = 'light' | 'dark';

interface DividerProps {
  className?: string;
  isOr?: boolean;
  color?: DividerColor;
  margin?: number;
}

/**
 * Divider displays a horizontal line with text in the middle.
 */
export const Divider = ({
  className,
  isOr = true,
  color = 'light',
  margin = 0,
}: DividerProps) => {
  return (
    <StyledDivider className={className} $color={color} $margin={margin}>
      <DividerLine $color={color} />
      {isOr && (
        <>
          OR
          <DividerLine $color={color} />
        </>
      )}
    </StyledDivider>
  );
};

interface StyledDividerProps {
  $color: DividerColor;
  $margin: number;
}
const StyledDivider = styled.div<StyledDividerProps>`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing[8]};
  width: 100%;
  color: ${(props) => {
    switch (props.$color) {
      case 'light':
        return props.theme.color.neutral[70];
      case 'dark':
        return props.theme.color.neutral[90];
    }
  }};
  font: ${(props) => props.theme.typography.body.xs.regular};
  margin: ${(props) => props.$margin}px 0;
`;

interface DividerLineProps {
  $color?: DividerColor;
}
const DividerLine = styled.div<DividerLineProps>`
  border-bottom: 1px solid
    ${(props) => {
      switch (props.$color) {
        case 'light':
          return props.theme.color.neutral[50];
        case 'dark':
          return props.theme.color.neutral[70];
      }
    }};
  flex: 1;
`;

Divider.displayName = 'Divider';

export default Divider;
